const DEFAULT_THEME_COLOR = '--global__background-color'

export function getElementStylePropertyValue(
  element: HTMLElement,
  property: string
) {
  return getComputedStyle(element).getPropertyValue(property)
}

export function setMetaThemeColor(color: string) {
  if (!color) {
    return
  }

  document
    ?.querySelector("meta[name='theme-color']")
    ?.setAttribute('content', color)
}

export function setDefaultMetaThemeColor() {
  document
    ?.querySelector("meta[name='theme-color']")
    ?.setAttribute(
      'content',
      getElementStylePropertyValue(
        document.documentElement,
        DEFAULT_THEME_COLOR
      )
    )
}
